import { createTheme } from '@mui/material/styles';

// Dark-first theme that picks up where the legacy SPA left off but cleaner.
// Adjust palette once the brand refresh lands.
export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#7c5cff' },
    secondary: { main: '#ff8a65' },
    background: { default: '#0a0a0a', paper: '#121212' },
  },
  typography: {
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1: { fontWeight: 700, letterSpacing: '-0.02em' },
    h2: { fontWeight: 700, letterSpacing: '-0.01em' },
  },
  shape: { borderRadius: 8 },
});
